import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  private readonly apiBases = [
    environment?.timeSheetManagement?.url,
    environment?.timeSheetManagement?.urlv2,
  ]
    .filter((base): base is string => !!base)
    .map((base) => base.replace(/\/+$/, ""));

  constructor(private cookieService: CookieService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.cookieService.get("accessToken");

    if (!token || !this.isApiRequest(request.url)) {
      return next.handle(request);
    }

    if (request.headers.has("Authorization")) {
      return next.handle(request);
    }

    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(authRequest);
  }

  private isApiRequest(url: string): boolean {
    return this.apiBases.some((baseUrl) => {
      if (!baseUrl) {
        return false;
      }

      return url.startsWith(baseUrl) || url.startsWith(`${baseUrl}/`);
    });
  }
}
